import { render } from "./physicalTest.vue?vue&type=template&id=02e66420"
import script from "./physicalTest.vue?vue&type=script&lang=js"
export * from "./physicalTest.vue?vue&type=script&lang=js"

import "./physicalTest.vue?vue&type=style&index=0&id=02e66420&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\sport.yanhuotiyu.com焱火pc端web网站\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__